import React from 'react';
import { FormControl, InputLabel } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import NativeSelect, { NativeSelectProps } from '@mui/material/NativeSelect';
import { alpha } from '@mui/material/styles';
import Icon from '@ui/Icon';

/**
 * @todo delete this native select component once admin is phased out
 */
export interface SelectProps extends NativeSelectProps {
  id: string;
  label?: string;
}

const ChevronDownIcon = (iconProps: any) => (
  <Icon type="chevronDown" {...iconProps} />
);

const useStyles = makeStyles<{ value?: any }>()((theme, { value }) => ({
  label: {
    color: theme.palette.text.primary,
    '& + div': {
      marginTop: theme.spacing(3),
    },
  },
  inputBaseRoot: {
    color: !value
      ? alpha(theme.palette.text.primary, 0.35)
      : theme.palette.text.primary,
    padding: theme.spacing(0.6875, 2),
    '&:focus:not(:disabled), &:hover:not(:disabled)': {
      borderRadius: `4px`,
      borderColor: theme.palette.inputs.active,
      color: theme.palette.text.primary,
      background: 'none',
    },
    '&:focus + svg, &:hover + svg': {
      color: theme.palette.text.primary,
    },
    '&:not(:empty)': {
      color: theme.palette.text.primary,
    },
  },
  selectIcon: {
    right: theme.spacing(1),
    top: theme.spacing(1.25),
    color: theme.palette.inputs.default,
  },
}));

/**
 * @deprecated - Use `<SingleSelect />` instead
 */
const Select = (props: SelectProps) => {
  const { id, label, fullWidth = true, value, ...rest } = props;
  const { classes } = useStyles({ value });
  return (
    <FormControl fullWidth={fullWidth}>
      {label && (
        <InputLabel className={classes.label} shrink htmlFor={id}>
          {label}
        </InputLabel>
      )}
      <NativeSelect
        id={id}
        fullWidth={fullWidth}
        variant="outlined"
        classes={{
          root: classes.inputBaseRoot,
          icon: classes.selectIcon,
        }}
        IconComponent={ChevronDownIcon}
        value={value}
        {...rest}
      />
    </FormControl>
  );
};

export default Select;
